exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabs-view-container[data-v-b93f3c44] {\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 10px;\n}\n.tabs-view-container .tabs-view[data-v-b93f3c44] {\n    margin-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b93f3c44","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/TabsView.vue
// module id = q98q
// module chunks = 182